<template>
  <a-card>
    <a-field :config="config.category" v-model="category" />
  </a-card>
</template>

<script>
import config from "../config/clientConfig";

export default {
  data() {
    return {
      config: config,
    };
  },
  computed: {
    category: {
      get() {
        return this.get("category");
      },
      set(newValue) {
        return this.set("category", newValue);
      },
    },
  },
  methods: {
    get(val) {
      return this.$store.getters["ClientStore/active"][val];
    },
    set(key, val) {
      return this.$store.dispatch("ClientStore/setUpdate", { key, val });
    },
  },
};
</script>
